export enum BuildingsConnectionGroupType {
  electricityConnectionGroup = "electricityConnectionGroup",
  gasConnectionGroup = "gasConnectionGroup"
}
